import gql from "graphql-tag";
const getResultQuery = gql(` 
query GetResult($params: AWSJSON!) {
  getResult(params: $params) {
    id
    status
    profile
    penalty
    coords
    cycles
    batches
    nearest
    distance
    geo
    meta
    quantity
    filtered
    result
    version
  }
}
`)
export default getResultQuery;
